import { render } from "./PlayerScreen.vue?vue&type=template&id=c03f1dce"
import script from "./PlayerScreen.vue?vue&type=script&lang=js"
export * from "./PlayerScreen.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__